<template>
  <div id="app">
    <div class="page-loading" v-if="pageLoading">
      <grid-loader :loading="pageLoading" :color="colorPrimary" size="10px" />
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import GridLoader from "vue-spinner/src/GridLoader.vue";

export default {
  name: "app",
  components: {
    GridLoader,
  },
  computed: {
    ...mapGetters({
      pageLoading: "pageLoading",
    }),
  },
};
</script>
